export default __webpack_public_path__ + "static/media/infra-26.232f8ae2.webp";